import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { AbTestGroupUserInputType } from '@/gql/graphql';

export const updateAbTestGroupUser = async (id: number, data: AbTestGroupUserInputType) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateAbTestGroupUser($id: Float!, $data: AbTestGroupUserInputType!) {
        updateAbTestGroupUser(id: $id, data: $data) {
          id
          userId
          abTestGroupId
          associatedObjectType
          associatedObjectId
          isActive
          abTestId
        }
      }
    `),
  });

  return response.data?.updateAbTestGroupUser;
};
